import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablasComunesService from 'services/tablasComunes.service'

import * as Modals from './modals'

const UnicoLista = ({ match }) => {
  const __zariContext = React.useContext(ZariContext)

  const [mostrarNuevoModal, setMostrarNuevoModal] = React.useState(false)
  const [mostrarEditarModal, setMostrarEditarModal] = React.useState(false)

  const tablaRef = React.useRef(null)
  const editarData = React.useRef(null)

  const nombreTabla = React.useMemo(() => {
    return TiposTablaComunConstant.__dictionary[match.params.tipoTabla].nombre
  }, [match.params.tipoTabla])

  const clickEditar = React.useCallback(
    ({ _id }) => {
      TablasComunesService.getAsEdicion(_id)
        .then(({ data }) => {
          editarData.current = {
            ...data,
            _id: _id
          }
          setMostrarEditarModal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    ({ _id }) => {
      TablasComunesService.eliminarxId(_id)
        .then(() => {
          __zariContext.snack('success', 'El registro se ha eliminado.')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header
          title={`${nombreTabla} - (${match.params.tipoTabla})`}
          buttons={[{ name: 'Nuevo', onClick: () => setMostrarNuevoModal(true) }]}
        />
        <Portlet.Body>
          <Table.ServerSide
            ref={tablaRef}
            useNest={true}
            url='/tablas-comunes'
            baseParams={{
              tipo: match.params.tipoTabla
            }}
            headRows={[{ label: 'CODIGO' }, { label: 'NOMBRE' }, { label: '' }]}
            rowTemplate={row => (
              <Table.Row key={row._id}>
                <Table.Cell>{row.codigo || '--'}</Table.Cell>
                <Table.Cell>{row.nombre || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item
                        key='editar'
                        handleClose={handleClose}
                        onClick={e => clickEditar({ _id: row._id })}
                      >
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item
                        key='eliminar'
                        handleClose={handleClose}
                        onClick={e => clickEliminar({ _id: row._id })}
                      >
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarNuevoModal && (
        <Modals.NuevoModal
          handleClose={e => setMostrarNuevoModal(false)}
          show={mostrarNuevoModal}
          reloadTable={tablaRef.current.reload}
          tipoTabla={match.params.tipoTabla}
        />
      )}
      {mostrarEditarModal && (
        <Modals.EditarModal
          handleClose={e => setMostrarEditarModal(false)}
          show={mostrarEditarModal}
          reloadTable={tablaRef.current.reload}
          modalData={editarData.current}
          tipoTabla={match.params.tipoTabla}
        />
      )}
    </>
  )
}

export default UnicoLista
